import { render, staticRenderFns } from "./PasoExtraRecintoAnexo.vue?vue&type=template&id=06398f57"
import script from "./PasoExtraRecintoAnexo.vue?vue&type=script&setup=true&lang=js"
export * from "./PasoExtraRecintoAnexo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports